module.exports = __webpack_public_path__ + "static/media/Chhiring with credit pages lat.f9359dd0.mp4";